import React, { lazy, type FunctionComponent } from 'react'
import { DashSwitch } from '../../legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from '../../legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from '../../legacy/dash-components/dash-redirect/DashRedirect'
import { bannersAdminRoutingConfig } from './utils/bannersRoutingConfig'
import LinksToNewBannerDetails from './components/banner-details/LinksToNewBannerDetails'

const BannersList = lazy(() => import('./components/banners-list/BannersList'))
const BannerCreate = lazy(() => import('./components/banner-create/BannerCreate'))
const BannerUpdate = lazy(() => import('./components/banner-update/BannerUpdate'))
const BannerDetails = lazy(() => import('./components/banner-details/BannerDetails'))

const VisibilityConditionsList = lazy(
  () => import('./components/visibility-conditions-list/VisibilityConditionsList')
)
const VisibilityConditionCreate = lazy(
  () => import('./components/visibility-condition-create/VisibilityConditionCreate')
)

// When this becomes an RPP domain, the totemEntity should be set to banners-dashboard-tool
export const BannersAdminSection: FunctionComponent = () => (
  <DashSwitch>
    <DashRoute exact route={bannersAdminRoutingConfig.list} component={BannersList} />
    <DashRoute exact route={bannersAdminRoutingConfig.create} component={BannerCreate} />
    <DashRoute exact route={bannersAdminRoutingConfig.edit} component={BannerUpdate} />
    <DashRoute exact route={bannersAdminRoutingConfig.details} component={BannerDetails} />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.visibilityConditions}
      component={VisibilityConditionsList}
    />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.visibilityConditionCreate}
      component={VisibilityConditionCreate}
    />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.detailsOld}
      component={LinksToNewBannerDetails}
    />
    <DashRoute
      exact
      route={bannersAdminRoutingConfig.editOld}
      component={LinksToNewBannerDetails}
    />
    <DashRedirect toRoute={bannersAdminRoutingConfig.list} />
  </DashSwitch>
)
